import SchemeBusinessService from '../services/scheme-business-service';

export const schemeBusinessWatchlist = {
  namespaced: true,
  state: {
    watchlistHistory: null,
  },
  actions: {
    listWatchlistHistory({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.listWatchlistHistory(payload.schemeId, payload.schemeBusinessId)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setWatchlistHistory', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    updateWatchlistHistory({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.updateWatchlistHistory(
        payload.schemeId,
        payload.schemeBusinessId,
        {
          schemeId: payload.schemeId,
          schemeBusinessId: payload.schemeBusinessId,
          watchListStatusDate: payload.watchListStatusDate,
          comments: payload.comments,
        }
      )
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    updateWatchlistStatus({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.updateWatchlistStatus(payload.schemeId, payload.schemeBusinessId, payload.watchListStatus)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setWatchlistHistory(state, newWatchlistHistory) {
      state.watchlistHistory = newWatchlistHistory;
    },
  },
};
